
export const InstallStatusNew = 0
export const InstallStatusDisabled = 1
export const InstallStatusEnabled = 2

export const DeviceStatusNone = 0
export const DeviceStatusOn = 1
export const DeviceStatusOff = 2

export const DeviceTypeSLC = 0
export const DeviceTypeLamp = 1

export const DeviceModeNone = 0
export const DeviceModeAuto = 1
export const DeviceModeManual = 2
export const DeviceModeBypass = 3
export const DeviceModeSunset = 4
export const DeviceModeTwilight = 5

// Device Error cases
export const EventTypePowerOff = 1001
export const EventTypeLowBattery = 1002
export const EventTypeEnergyMeterCommFailure = 1003
export const EventTypeManualMode = 1004
export const EventTypeBypassMode = 1005
export const EventTypeDoorOpen = 1006
export const EventTypeDoorOpenContinous = 1007
export const EventTypeLampOff = 1008
export const EventTypeTheft = 1009
export const EventTypeIsolatorOff = 1010
export const EventTypeSmpsFail = 1011

// Load error cases
export const EventTypeInputSenseFailR = 2001
export const EventTypeInputSenseFailY = 2002
export const EventTypeInputSenseFailB = 2003
export const EventTypeMCBTripR = 2004
export const EventTypeMCBTripY = 2005
export const EventTypeMCBTripB = 2006
export const EventTypeLoadSenseFailR = 2007
export const EventTypeLoadSenseFailY = 2008
export const EventTypeLoadSenseFailB = 2009
export const EventTypeLowVoltR = 2010
export const EventTypeLowVoltY = 2011
export const EventTypeLowVoltB = 2012
export const EventTypeHighVoltR = 2013
export const EventTypeHighVoltY = 2014
export const EventTypeHighVoltB = 2015
export const EventTypeOverCurrR = 2016
export const EventTypeOverCurrY = 2017
export const EventTypeOverCurrB = 2018

// Server generared events
export const EventTypeDeviceInactive = 5001

// Error Groups
export const EventGrpLowVoltage = 0
export const EventGrpHighVoltage = 1
export const EventGrpPowerFailure = 2
export const EventGrpMcbTrip = 3
export const EventGrpHighCurrent = 4
export const EventGrpContactorFailure = 5
export const EventGrpEnergyMeterFail = 6
export const EventGrpDoorOpen = 7
export const EventGrpLowBattery = 8
export const EventGrpInActiveCnt = 9
export const EventGrpIsolatorFail = 10
export const EventGrpMax = 11

// Error Category
export const EventCatDefault = 0
export const EventCatInpFaults = 1
export const EventCatOutFaults = 2

export const errGrpInfoArray = [
    {
        grpId: EventGrpLowVoltage,
        errCodes: [EventTypeLowVoltR, EventTypeLowVoltY, EventTypeLowVoltB]        
    },
    {
        grpId: EventGrpHighVoltage,
        errCodes: [EventTypeHighVoltR, EventTypeHighVoltY, EventTypeHighVoltB]        
    },
    {
        grpId: EventGrpPowerFailure,
        errCodes: [EventTypeInputSenseFailR, EventTypeInputSenseFailY, EventTypeInputSenseFailB, EventTypeSmpsFail]        
    },
    {
        grpId: EventGrpMcbTrip,
        errCodes: [EventTypeMCBTripR, EventTypeMCBTripY, EventTypeMCBTripB]        
    },
    {
        grpId: EventGrpHighCurrent,
        errCodes: [EventTypeOverCurrR, EventTypeOverCurrY, EventTypeOverCurrB]        
    },
    {
        grpId: EventGrpContactorFailure,
        errCodes: [EventTypeLoadSenseFailR, EventTypeLoadSenseFailY, EventTypeLoadSenseFailB]        
    },
    {
        grpId: EventGrpEnergyMeterFail,
        errCodes: [EventTypeEnergyMeterCommFailure]        
    },
    {
        grpId: EventGrpDoorOpen,
        errCodes: [EventTypeDoorOpen, EventTypeDoorOpenContinous]        
    },
    {
        grpId: EventGrpLowBattery,
        errCodes: [EventTypeLowBattery]        
    },
    {
        grpId: EventGrpInActiveCnt,
        errCodes: [EventTypeDeviceInactive]        
    },
    {
        grpId: EventGrpIsolatorFail,
        errCodes: [EventTypeIsolatorOff]        
    }
];
